import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import BaseGoalsDummyRepository from './infrastructure/repositories/base-goals-dummy-repository/base-goals-dummy-repository';
import BaseGoalsHttpRepository from './infrastructure/repositories/base-goals-http-repository';

// Application
import UpdateBaseGoalsCommand from './application/command/update-base-goals-command';

// Domain
import { BaseGoalsRepository } from './domain/repositories/base-goals-repository';

export default function setupBaseGoals(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<BaseGoalsRepository>(
      TYPES.BASE_GOALS_REPOSITORY,
    ).to(
      withDummies
        ? BaseGoalsDummyRepository
        : BaseGoalsHttpRepository,
    ).inSingletonScope();

  container
    .bind<UpdateBaseGoalsCommand>(
      TYPES.UPDATE_BASE_GOALS_COMMAND,
    ).to(UpdateBaseGoalsCommand)
    .inSingletonScope();
}
